import { SEEK_FACEBOOK_URL, SEEK_TWITTER_URL } from '@seek/shared-constants';
import {
  Box,
  Column,
  Columns,
  IconSocialFacebook,
  IconSocialX,
  Inline,
  Text,
} from 'braid-design-system';
import { vars } from 'braid-design-system/css';
import type React from 'react';

import { TextLink } from 'src/components';
import { TRACKING_CODES } from 'src/shared/constant';
import type { Site } from 'src/shared/types';

interface Props {
  site: Site;
}

const SocialMediaBox: React.FC<Props> = ({ site }) => (
  <Box>
    <Columns space="small" collapseBelow="desktop">
      <Column>
        <Inline space="medium">
          <Box borderRadius="full" background="neutralLight">
            <IconSocialFacebook />
          </Box>
          <Text baseline={false}>
            <TextLink
              target="_blank"
              href={SEEK_FACEBOOK_URL[site]}
              tracking={TRACKING_CODES.content_element_pressed}
              trackingProps={{
                elementDesign: 'link',
                elementText: 'fb.me/SEEK',
              }}
            >
              <span style={{ color: vars.foregroundColor.neutral }}>
                fb.me/SEEK
              </span>
            </TextLink>
          </Text>
        </Inline>
      </Column>
      <Column>
        <Inline space="medium">
          <Box borderRadius="full" background="neutralLight">
            <IconSocialX />
          </Box>
          <Text baseline={false}>
            <TextLink
              target="_blank"
              href={SEEK_TWITTER_URL[site]}
              tracking={TRACKING_CODES.content_element_pressed}
              trackingProps={{
                elementDesign: 'link',
                elementText: '@seekjobs',
              }}
            >
              <span style={{ color: vars.foregroundColor.neutral }}>
                @seekjobs
              </span>
            </TextLink>
          </Text>
        </Inline>
      </Column>
    </Columns>
  </Box>
);

export default SocialMediaBox;
